// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const $eventVal = (event: any): string => {
    return event.target.value
}
